/* globals angular */
(function(){
  'use strict';

  var receiverParser = {
    template: require('./receiver-parser.html'),
    controller: 'ReceiverParserCtrl',
    bindings: {
      receiver: '<',
      tracking: '<',
    },
  };

  angular
    .module('mandaeApp')
    .component('receiverParser', receiverParser);
}());
